<adapt-filter-content (reset)="resetOptions()"
                      [disabled]="disabled"
                      [tooltipContent]="tooltipContent"
                      [isDefault]="isDefaultOverride ?? isDefaultFilter"
                      [urlParamNames]="OrganisationMapFilterParamKeys">
    <div class="form-group d-flex flex-column gap-2">
        <dx-check-box text="Show only my teams"
                      [(value)]="currentFilter.showMyTeams"
                      (valueChange)="emitFilterChanged()"></dx-check-box>
        <dx-check-box text="Show private teams"
                      [(value)]="currentFilter.showPrivateTeams"
                      (valueChange)="emitFilterChanged()"></dx-check-box>
        <div>
            <dx-check-box text="Show inactive groups"
                          [(value)]="currentFilter.showEndedTeams"
                          (valueChange)="emitFilterChanged()"></dx-check-box>
            <p class="small opacity-75 m-0">Inactive groups with active groups located within them are always shown.</p>
        </div>
    </div>
    <div class="form-group d-flex flex-column gap-2">
        <label>Show Supplementary Data</label>
        <dx-tag-box [items]="supplementaryDataOptions"
                    [(value)]="currentFilter.supplementaryData"
                    (valueChange)="emitFilterChanged()"
                    [showSelectionControls]="true"
                    [showClearButton]="true"
                    [showDropDownButton]="true"
                    [disabled]="disabled"
                    displayExpr="text"
                    valueExpr="value"
                    applyValueMode="instantly"
                    data-test="filter-org-map-supplementary-data"></dx-tag-box>
    </div>
</adapt-filter-content>
